import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import StepRoutes from "../../../Routes/steps_routes";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import Pagination from "../../../Components/layouts/pagination";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import ViewAllEEP from "./view_all_eep";
import { BsRocket } from "react-icons/bs";
import getFilteredURL from "../../../Components/Functions/filters.getUrl";
import { useSelector } from "react-redux";
import SimpleButton from "../../../Components/layouts/simple_button";
import { useLocation, useNavigate } from "react-router";
import { FcRules } from "react-icons/fc";

const AllEEP = () => {
  const [refresh, setRefresh] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const pageFromURL = parseInt(queryParams.get("page")) || 1;
  const [page, setPage] = useState(pageFromURL);

  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [data, setData] = useState([]);
  const [employeeList, setEmployeeList] = useState([]); 
  let role = useSelector((store) => store?.login?.user?.Role);
  const store = useSelector((store) => store?.login?.user);
  const [showPenaltyModal, setShowPenaltyModal] = useState(false);
  const [penaltyData, setPenaltyData] = useState({
    employeeId: "",
    penaltyReason: "",
  });

  const canShowPenalty =
    store?.Role === "superAdmin" || store?.Role === "adminStaff";

  useEffect(() => {
    navigate(`?page=${page}`, { replace: true });
  }, [page, navigate]);

  useEffect(() => {
    performRequest(
      "GET",
      getFilteredURL("/eep/getAllEep", page, {
        role: store?.Role,
        userId: store?.UserId,
      })
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setTotalPages(Math.ceil(res.data?.allEepDataCount / 50));
        } else {
          Toast("error", "Error while getting employee efficiency program");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [refresh, page]);

  useEffect(() => {
    performRequest("GET", "/eep/allEmployeeData")
      .then((res) => {
        if (res.status === 201) {
          setEmployeeList(res.data);
        }
      })
      .catch((err) => CustomErrorResponse(err));
  }, []);

  return (
    <div className="page">
      <div className="page-wrapper">
        <div style={{ minHeight: "80vh" }}>
          <div className="page-header d-print-none">
            <div className="container-xl">
              <div className="row g-2 align-items-center">
                <div className="col">
                  <div className="d-flex justify-content-between align-items-center">
                    <h2 className="page-title mb-0">
                      <BsRocket
                        className="fs-2 me-1"
                        style={{ color: "darkorange" }}
                      />
                      Employee Efficiency Program
                    </h2>

                    {canShowPenalty && (
                      <SimpleButton
                        buttonText="Penalty"
                        type="danger"
                        onClick={() => setShowPenaltyModal(true)}
                      />
                    )}
                  </div>

                  <h4 className="text-muted">
                    <StepRoutes />
                  </h4>
                </div>
              </div>
            </div>
          </div>

          {showPenaltyModal && (
            <div
              className="modal d-block"
              tabIndex="-1"
              style={{
                backgroundColor: "rgba(0,0,0,0.4)",
                backdropFilter: "blur(5px)",
              }}
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  {/* Header */}
                  <div className="modal-header">
                    <h5 className="modal-title">Add Penalty</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setShowPenaltyModal(false)}
                    ></button>
                  </div>

                  {/* Body */}
                  <div className="modal-body">
                    {/* Employee Name */}
                    <div className="mb-3">
                      <label className="form-label">Employee Name</label>
                      <select
                        className="form-select"
                        value={penaltyData.employeeId}
                        onChange={(e) =>
                          setPenaltyData({
                            ...penaltyData,
                            employeeId: e.target.value,
                          })
                        }
                      >
                        <option value="">Select Employee</option>

                        {employeeList.map((emp) => (
                          <option key={emp.id} value={emp.id}>
                            {emp.fullName}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Penalty Reason */}
                    <div className="mb-3">
                      <label className="form-label">Penalty Reason</label>
                      <select
                        className="form-select"
                        value={penaltyData.penaltyReason}
                        onChange={(e) =>
                          setPenaltyData({
                            ...penaltyData,
                            penaltyReason: e.target.value,
                          })
                        }
                      >
                        <option value="">Select Reason</option>
                        <option value="fake_task_completion">
                          Fake Task Completion
                        </option>
                        <option value="false_reporting">False Reporting</option>
                        <option value="data_manipulation">
                          Data Manipulation
                        </option>
                        <option value="crm_data_deletion_hiding">
                          CRM Data Deletion / Hiding
                        </option>
                      </select>
                    </div>
                  </div>

                  {/* Footer */}
                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary"
                      onClick={() => setShowPenaltyModal(false)}
                    >
                      Cancel
                    </button>

                    <button
                      className="btn btn-danger"
                      onClick={() => {
                        if (
                          !penaltyData.employeeId ||
                          !penaltyData.penaltyReason
                        ) {
                          Toast("error", "Please fill all fields");
                          return;
                        }

                        const selectedEmployee = employeeList.find(
                          (emp) => emp.id === Number(penaltyData.employeeId)
                        );

                        performRequest("POST", "/eep/applyPenalty", {
                          employeeId: selectedEmployee.id,
                          employeeName: selectedEmployee.fullName,
                          employeeEmail: selectedEmployee.emailId,
                          penaltyReason: penaltyData.penaltyReason,
                          genratedBy: store.Name,
                          genratedById: store.UserId,
                          penaltyDate: new Date().toISOString().split("T")[0],
                        })
                          .then((res) => {
                            if (res.status === 201) {
                              Toast("success", "Penalty applied successfully");

                              // close modal
                              setShowPenaltyModal(false);

                              // reset form
                              setPenaltyData({
                                employeeName: "",
                                penaltyReason: "",
                              });

                              // refresh list (optional)
                              setRefresh(!refresh);
                            } else {
                              Toast("error", "Failed to apply penalty");
                            }
                          })
                          .catch((err) => {
                            CustomErrorResponse(err);
                          });
                      }}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="page-body">
            <div className="container-xxl">
              <div className="row">
                {/* Left Side - Policy Card */}
                <div className="col-md-4">
                  <div className="card mt-2">
                    <div
                      style={{
                        backgroundColor: "rgb(100, 149, 237, 0.12)",
                      }}
                    >
                      <div className="card-header">
                        <h3 className="card-title">
                          <FcRules className="fs-2 me-1" />
                          EEP Calculation Policy
                        </h3>
                      </div>

                      <div
                        className="card-body"
                        style={{
                          maxHeight: "300px", // adjust height as needed
                          overflowY: "auto",
                        }}
                      >
                        <h3>Task Score Calculation</h3>
                        <ul>
                          <li>
                            The Work Output Score is calculated based on task
                            difficulty assigned to the employee.
                          </li>
                          <li>
                            If the task difficulty is{" "}
                            <strong>Micro, +1 point</strong> is added to the EEP
                            score.
                          </li>
                          <li>
                            If the task difficulty is{" "}
                            <strong>Small, +3 points</strong> are added to the
                            EEP score.
                          </li>
                          <li>
                            If the task difficulty is{" "}
                            <strong>Medium, +6 points</strong> are added to the
                            EEP score.
                          </li>
                          <li>
                            If the task difficulty is{" "}
                            <strong>Major, +12 points</strong> are added to the
                            EEP score.
                          </li>
                        </ul>

                        <h3>Discipline Score</h3>
                        <ul>
                          <li>
                            If an employee logs in late,{" "}
                            <strong>-1 point</strong> is deducted from the EEP
                            score.
                          </li>
                          <li>
                            If an employee misses the daily scrum,{" "}
                            <strong>-1 point</strong>is deducted.
                          </li>
                          <li>
                            If an employee does not update the daily scrum in
                            the system, <strong>-2 points</strong> are deducted.
                          </li>
                          <li>
                            If an employee forgets to log out,
                            <strong>-1 point</strong> is deducted.
                          </li>
                          <li>
                            If an employee takes leave without approval before
                            the leave date,<strong>-5 points</strong> are
                            deducted.
                          </li>
                          <li>
                            If an employee logs in late repeatedly (3 times in a
                            week), an <strong>additional -3 points</strong> are
                            deducted.
                          </li>
                        </ul>

                        <h3>Attendance Score</h3>
                        <ul>
                          <li>
                            If an employee logs in and logs out properly,
                            <strong>no points are added or deducted.</strong>
                          </li>
                          <li>
                            If an employee works less than
                            <strong>4.5 hours, -2 points</strong> are deducted.
                          </li>
                        </ul>

                        <h3>Learning and Training Score</h3>
                        <ul>
                          <li>
                            If an employee completes an internal training
                            program, <strong>+2 points</strong> are added.
                          </li>
                          <li>
                            If an employee passes a skill test,{" "}
                            <strong>+3 points</strong> are added.
                          </li>
                        </ul>

                        <h3>Penalty Score</h3>
                        <ul>
                          <li>
                            Penalties can be applied by the{" "}
                            <strong>Super Admin or Admin.</strong>
                          </li>
                          <li>
                            If an employee performs{" "}
                            <strong>fake task completion, -20 points</strong>{" "}
                            are deducted from the final EEP score.
                          </li>
                          <li>
                            If an employee engages in{" "}
                            <strong>false reporting, -20 points</strong> are
                            deducted from the final EEP score.
                          </li>
                          <li>
                            If an employee is involved in{" "}
                            <strong>data manipulation, -30 points</strong> are
                            deducted from the final EEP score.
                          </li>
                          <li>
                            If an employee deletes or hides{" "}
                            <strong>CRM data, -30 points</strong> are deducted
                            from the final EEP score.
                          </li>
                          <li>
                            Penalties are applied{" "}
                            <strong>for each instance of misconduct</strong> by
                            the employee.
                          </li>
                        </ul>

                        <h3>EEP Score Calculation Formula</h3>
                        <ul>
                          <strong>
                            EEP Score = 100 + Work Output Score + Discipline
                            Score + Attendance Score + Learning and Training
                            Score
                          </strong>
                        </ul>

                        <h3>Monthly Performance Band</h3>
                        <ul>
                          <li>
                            If the EEP score is{" "}
                            <strong>120 or above → Top Performer</strong>
                          </li>
                          <li>
                            If the EEP score is{" "}
                            <strong>110–119 → Strong Performer</strong>
                          </li>
                          <li>
                            If the EEP score is{" "}
                            <strong>95–109 → Normal Performer</strong>
                          </li>
                          <li>
                            If the EEP score is{" "}
                            <strong>80–94 → Needs Improvement</strong>
                          </li>
                          <li>
                            If the EEP score is{" "}
                            <strong>below 80 → At Risk Employee</strong>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right Side - Table */}
                <div className="col-md-8">
                  <div className="card mt-2">
                    <ViewAllEEP
                      data={data}
                      currentPage={page}
                      itemsPerPage={50}
                    />

                    <Pagination
                      page={page}
                      setPage={setPage}
                      totalPages={totalPages}
                      pageDatalength={data?.allEepData?.length}
                      showPage={showPage}
                      setShowPage={setShowPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default AllEEP;
